export const SERVICE_V2 = 'v2';
export const SERVICE_LIVESTORIES = 'livestories';
export const SERVICE_LIVECOMMENT = 'livecomment';
export const SERVICE_LIVECHAT = 'livechat';
